import { ClipboardModule } from '@angular/cdk/clipboard';
import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { TooltipModule } from 'primeng/tooltip';
import { OpenIntercomDirective } from '@app/shared/directives/open-intercom.directive';

@Component({
  selector: 'lfx-contact-support',
  standalone: true,
  imports: [CommonModule, ButtonModule, ClipboardModule, TooltipModule, OpenIntercomDirective],
  templateUrl: './contact-support.component.html',
  styleUrls: ['./contact-support.component.scss'],
})
export class ContactSupportComponent implements OnInit {
  public copyText: string = 'Copy';

  private readonly dialogConfig = inject(DynamicDialogConfig);

  public constructor() {}

  public ngOnInit(): void {}

  public get errorStack(): string {
    return this.dialogConfig?.data?.error || '';
  }

  public onClickCopy(): void {
    this.copyText = 'Copied!';
    setTimeout(() => {
      this.copyText = 'Copy';
    }, 2000);
  }
}
